module.exports = __webpack_public_path__ + "static/media/nov2024-1.0a952bdb.webp";